import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { BreadcrumbService } from 'xng-breadcrumb';
import { BaseDbDto } from '@ellf/common-dto';
import { FilterValue } from '@ellf/common-interfaces';

export class ListGuard<T extends BaseDbDto> {
  constructor(private breadcrumb: BreadcrumbService) {}

  filtersObjList: FilterValue[] = [];
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.setBreadcrumb();
    return of(true);
  }

  setBreadcrumb() {
    this.breadcrumb.set('@entityList', {
      skip: true,
    });
  }
}
